import type { FC } from 'react';
import { ViewSvg } from '../../../../components/svg/view-svf';
import { ActivitySvg } from '../../../../components/svg/activity-svg';
import { FileSvg } from '../../../../components/svg/file-svg';
import type { OptionItem } from '../../../../common/types/option-item';

export const tabList: { id: string; title: string; icon?: FC }[] = [
  { id: 'views', title: 'Огляд', icon: ViewSvg },
  { id: 'activity', title: 'Активність', icon: ActivitySvg },
  { id: 'files', title: 'Файли', icon: FileSvg }
];

export const activityTabs: OptionItem[] = [
  { id: 'activity', title: 'Активність' },
  { id: 'note', title: 'нотатки' },
  { id: 'letter', title: 'листи' },
  { id: 'calls', title: 'Дзвінки' },
  { id: 'meet', title: 'зустрічі' }
];
